import DrugList from "./DrugList";

export default DrugList;